import { DependencyList, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

interface ScrollToTopProps {
  options?: ScrollToOptions
  id?: string
}

export const scrollToTop = ({ options, id = 'root' }: ScrollToTopProps = {}): void => {
  const element = document.getElementById(id)
  if (element) {
    element.scrollTo({ top: 0, behavior: 'smooth', ...options })
    return
  }
}

interface UseScrollToTopProps {
  effect?: DependencyList
  id?: string
}

export const useScrollToTop = ({ effect = [], id }: UseScrollToTopProps = {}): null => {
  useEffect(() => {
    // Prevent the browser from restoring the scroll position when navigating back,
    // allowing scrollToTop to work without interference.
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual'
    }
    scrollToTop({ id })
    return () => {
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'auto'
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, ...effect])

  return null
}

export const useScrollToTopOnRouteChange = (): void => {
  const { pathname } = useLocation()

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual'
    }

    // small delay to ensure the DOM is fully rendered
    const timeout = setTimeout(() => {
      scrollToTop()
    }, 100)

    return () => {
      clearTimeout(timeout)
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'auto'
      }
    }
  }, [pathname])
}
